// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"463":"057b8482","651":"4f034e44","694":"8470c3be","896":"2d24eac6"}[chunkId] + ".css";
};